/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".view-media-bar{display:-webkit-box;display:flex}.view-media-bar__scrubber{width:160px}"];
export { styles as styles };
